export default __webpack_public_path__ + "static/media/coppa.17724a43.png";